module.exports = __webpack_public_path__ + "img/29.974ce7d2.jpg";